import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, of} from 'rxjs';

import { Subscription } from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
// import { JobPlaintiff } from 'src/app/shared/models/jobPlaintiff.model';
import { AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';

import { JobSubjectDocument } from './../../../shared/models/jobSubjectDocument.model';


@Component({
  selector: 'app-job-subject-document-add-widget',
  templateUrl: './job-subject-document-add-widget.component.html',
  styleUrls: ['./job-subject-document-add-widget.component.css']
})
export class JobSubjectDocumentAddWidgetComponent implements OnInit {
   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   job: Object;
   job_id;

   @Input() intialCount? = 221;
   @Input() count? = this.intialCount;
   @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
   @Input() subject_id? // Observable<any[]> // changed to an observable.
   @Input() subject_name?;

   model: JobSubjectDocument;
 job_plaintiff_types: Object;


     // defined the array of complex data
     public sportsData: string[] = ['Badminton', 'Basketball', 'Cricket', 'Football', 'Golf', 'Gymnastics'];
     // set a value to pre-select
     public value: string = '';
 job_plaintiffs: any;
 allPlaintiffs: any;
 allPlantiffs_menu: any;
  job_number: any;
  allSubjectDocuments: any[];
  job_subject_documents: Object;
  allSubjectDocuments_menu: any[];
  subject_number: any;
  subject: Object;
  subject_business_name: any;


 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
 ) { }

 // check for changes. to load data.
 ngOnChanges(changes) {

   this.model = new JobSubjectDocument();
  //  this.getJobPlaintiffTypes();
  //  this.getAllJobPlaintiffs();

  this.getAllJobSubjectDocuments();

   if (changes.item_id) {
     // deal with asynchronous Observable result
     this.job_id = changes.item_id.currentValue;
     this.model.job_id = this.job_id;
     this.getJob(this.job_id);
   }

   if(this.subject_id != null ){
    // if(this.subject_id != null ){
    this.subject_id = changes.subject_id.currentValue;
    console.log('Subject ID: ' + this.subject_id);
    this.getJobSubject(this.subject_id);
   }
 }


 ngOnInit() {
 }



 // Functions
getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];
     // Run the job data queries.
     this.job_number = res.job_number;
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
    data => { this.subject = data;
      let res = data[0];
      this.subject_number = res.subject_number;
      // this.job_number = res.job_id + '.1'; // made up
     // console.log("Done loadng USER");

this.subject_number = res.subject_number;    
this.subject_name = res.first_name + '' + res.surname;
this.subject_business_name = res.business_name;

        if(this.subject_business_name != ''){
             this.subject_name = this.subject_business_name;
         }


         this.model.subject_id = this.subject_id;
         this.model.subject_number = this.subject_number;
         this.model.subject_name = this.subject_name;


    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }

addJobPlaintiff(model) {
 this._demoService.addJobPlaintiff(model).subscribe(
   data => { },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
//  this.toastr.info('Plaintiff & Type Added');
 this.closeParentModel.emit();
}


addJobSubjectDocument(model) {
  this.model.subject_id = this.subject_id;
  this.model.subject_number = this.subject_number;
  this.model.subject_name = this.subject_name;
  this.model.job_id = this.job_id;
  this.model.job_number = this.job_number;
  this._demoService.addJobSubjectDocument(model).subscribe(
    data => { },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
  // this.toastr.info('Document Added');
  this.closeParentModel.emit();
 }
 



getJobPlaintiffTypes() {
 this._demoService.getJobPlaintiffTypes().subscribe(
    data => { this.job_plaintiff_types = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



getAllJobPlaintiffs() {
 this.allPlaintiffs = [];
 this._demoService.getAllJobPlaintiffs().subscribe(
    data => { this.job_plaintiffs= data;
   
     let newArr = data;
     let  count_of_items = Object.keys(newArr).length;
       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
       let res = newArr[i];
       this.allPlaintiffs.push(
         res.job_plaintiff_name
       );
       } // end for loop
   
       console.log('this.allPlaintiffs: ', JSON.stringify(this.allPlaintiffs));
        this.allPlantiffs_menu = this.allPlaintiffs; //
       // console.log('result', this.allPlantiffs_menu);

   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


getAllJobSubjectDocuments() {
  this.allSubjectDocuments = [];
  this._demoService.getAllJobSubjectDocumentss().subscribe(
     data => { this.job_subject_documents = data;
    
      let newArr = data;
      let  count_of_items = Object.keys(newArr).length;
        // need to do a loop of subject_billing items (.length)
        for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
        this.allSubjectDocuments.push(
          res.document_name
        );
        } // end for loop
    
        // console.log('this.allSubjectDocuments: ', JSON.stringify(this.allSubjectDocuments));
         this.allSubjectDocuments_menu = this.allSubjectDocuments; //
        // console.log('result', this.allPlantiffs_menu);
 
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





}
